import React from 'react'
import '../css/home.css'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
    <div className='home-app'>
        <div className='box'><p>NFT & Chain Gaming</p></div>
        <div className='heading'>Tron’s Ultra Realistic <div>Game Character Creation Engine</div> </div>
        <div className='s-heading'>3DMM with RGB-D Face Reconstruction & Hybrid CNN Technology</div>
        <div className='s-heading'>built for <b>UNREAL ENGINE</b></div>
        <Link to='/demo'><button className='button'>Experience with our demo</button></Link>
    </div>
  )
}

export default Home
